import React, {useMemo} from 'react';
import {
    HomepageLogos, OpenPageCardsContainer,
    StrapiLayout,
} from "@klear/open-site";
import useIndexData from "../data/indexData";
const {Helmet} = require("react-helmet");


const styles = require('../styles/creators-document.module.scss');

export default () => {
     const allData = useIndexData();
     const creatorsData = allData.strapiCreator;
     const footerData = allData.strapiFooter;

    const topCardContent = useMemo(() =>
            <img src={creatorsData.topCard.image?.url} alt=""/>
        , []);

    return (
        <StrapiLayout footerProps={footerData}>
            <Helmet>
                <title>{creatorsData.title}</title>
                <meta name="description" content={creatorsData.description}/>
            </Helmet>
            <div className={styles.container}>
                <OpenPageCardsContainer topCard={{...creatorsData.topCard, topCardContent}}
                                        middleCards={creatorsData.middleCards}
                                        ctaText={creatorsData.ctaText} modalType={creatorsData.modalType}
                                        demoRequestBottomCard={creatorsData.requestDemoSection}
                                        horizontalTopCard={true} showDemoRequestCard={false}>
                    <HomepageLogos {...creatorsData.customerLogos} />
                </OpenPageCardsContainer>
            </div>
        </StrapiLayout>

    );
};